import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/inter';
import './meyer-reset.css';
import './react-loading-skeletons.css';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SkeletonTheme } from 'react-loading-skeleton';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SkeletonTheme>
      <App />
    </SkeletonTheme>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
